<template>
  <div class="outer-wrapper">
      <div class="title">
        <p>签名管理</p>
    </div>
    <Tabs>
      <TabPane label="全部人员签名" icon="logo-buffer">
        <query-list
          :columnsFormatData="columnsFormatData"
          :askData="askData"
          :refreshData="update_count"
          main_width="1280px"
        ></query-list>
      </TabPane>
      <Button @click="openModal('newCreate')" slot="extra" type="primary">新增签名</Button>
    </Tabs>
    <Modal
      v-model="modalValue.newCreate"
      :width="600"
      :mask-closable="false"
      :closable="false"
    >
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新建签名</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>人员姓名：</td>
              <td>
                <input
                  type="text"
                  placeholder="姓名"
                  v-model="name"
                  style="width:400px;"
                />
              </td>
            </tr>
           
            <tr>
              <td>签名图片：</td>
              <td>
                <Upload
                type="drag"
                action
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="(value)=>handleBeforeUpload(value)"
                style="width:400px;outline:none;border:none;"
              >
                <div style="width:400px;height:150px;">
                  <img style="width:100%;" :src="signatureImg.imgUrl" />
                  <p>点击上传</p>
                </div>
              </Upload>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newCreateSubmit('newCreate')"  >提交</Button>
        <Button size="large" @click="closeModal('newCreate')" >取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import queryList from "@/components/Common/QueryList.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";

function getObjectURL(file) {
  var url = null;
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}


export default {
  name: "signature",
  props: [],
  components: {
    queryList
  },
  data() {
    return {
      op_name: this.$options.name,
      askData: "signatureList",
      update_count: 0,
      modalValue:{
          newCreate:false,
      },
      name:'',
      signatureImg:{},
      columnsFormatData: [
        {
          title: "姓名",
          key: "name",
          align: "center"
        },
        {
          title: "签名",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "img",
                {
                  style: {
                    width:'240px',
                    height:'90px',
                  },
                  attrs:{src:this.$fileUrlFac(params.row.url,authData.sfileRight)}
                },
                ''
              )
            ]);
          }
        },
        {
          title: "创建时间",
          key: "create_time",
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red",marginRight:'5px' },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              ),
              
            ]);
          }
        }
        
      ]
    };
  },
  computed:{

  },
  methods: {
    handleSuccess() {},
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select jpg or png."
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "Exceeding file size limit",
        desc: "File  " + file.name + " is too large, no more than 2M."
      });
    },
    handleBeforeUpload(file) {
      this.signatureImg.imgObj = file;
      let objUrl = getObjectURL(file);
      if (objUrl) {
        this.signatureImg.imgUrl = objUrl;
      }
      this.$forceUpdate();
      return false;
    },
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value){
        this.modalValue[value] = true;
    },
    closeModal(value){
        this.modalValue[value] = false;
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "签名：" +
          value.name +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.id);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delSignature",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    newCreateSubmit(value){
      let form = new FormData();
        form.append("userToken", userToken);
        form.append("signatureImg", this.signatureImg.imgObj);
        form.append("name", this.name);
        form.append("askData", "createSignature");
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        this.$axios
          .post(this.$url + "/process", form, config)
          .then(response => {
            if (response.data.stat === "ok") {
              this.$Message.success("新建成功！");
              this.update_count++;
              this.closeModal(value);
            } else {
              this.$Message.error(response.data.info);
            }
          })
          .catch(error => {
            this.$Message.error(error + "未知错误！");
          });
    },
  }
};
</script>
<style scoped>
.outer-wrapper{
    width:1280px;
    margin:0 auto;
}
.title{
  text-align: center;
  margin:10px auto;
  font-size:20px;

}
.cr-form{
    width:100%;
    border-collapse: collapse;
}

.cr-form td{
    height:45px;
}

.cr-form td:first-child{
    text-align: right;
}

.cr-form input{
    padding: 0 10px;
    outline: none;
    height:30px;
    border-radius: 2px;
    border:1px solid #aaa;
}
</style>